import { manageReportUser } from "../../actions/reportUser/manageReportUser";
import showToaster from "../../helpers/toasterMessages/showToaster";

async function submit(values, dispatch, props) {
    if (!values.reportId) {
        showToaster({ messageId: 'notReportContent', toasterType: 'error' })
    }
    await dispatch(manageReportUser(values, props))
}

export default submit;